var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRootLink)?_c('AppRouterLink',{staticClass:"link",class:[_vm.hoverBehavior, { 'with-raquo': _vm.withRightAngleQuote }],attrs:{"title":_vm.title,"path":"/"}},[_vm._t("default")],2):(_vm.url !== null)?_c('a',{staticClass:"link",class:[
        _vm.hoverBehavior,
        _vm.buttonThemeClass,
        { 'with-raquo': _vm.withRightAngleQuote, button: _vm.renderAsButton } ],attrs:{"target":_vm.target,"title":_vm.title,"href":_vm.url}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }